import React, { useState, useEffect } from "react";

import { IBusDetail, ITripDetail } from "../../../../models/trip";
import { ErrorPopup } from "../../../../utilities/swal";
import { Button, Modal, Input } from "antd";
import { changeNumberBusApi } from "../../../../apis/bus.api";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonRenameBusProps {
  onSetTrip: React.Dispatch<React.SetStateAction<ITripDetail | null>>;
  bus: IBusDetail;
}

const ButtonRenameBus: React.FC<ButtonRenameBusProps> = ({
  bus,
  onSetTrip,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [busNumber, setBusNumber] = useState<number | "">("");
  useModalLockScroll(isModalOpen);
  useEffect(() => {
    setBusNumber(bus?.busNumber); // set mặc định là number
  }, [bus]);

  const showModal = () => setIsModalOpen(true);

  const handleCancel = () => {
    if (loading) return;
    setIsModalOpen(false);
  };

  const handleUpdateBus = async () => {
    if (busNumber === "" || busNumber <= 0) {
      ErrorPopup("Số xe phải là số hợp lệ");
      return;
    }

    try {
      setLoading(true);

      const rs = await changeNumberBusApi(bus?._id, busNumber);

      if (rs?.success) {
        onSetTrip((prev) => {
          if (!prev) return prev;

          return {
            ...prev,
            buses: prev.buses.map((b) =>
              b._id === bus._id ? { ...b, busNumber: rs?.data.busNumber } : b
            ),
          };
        });

        setIsModalOpen(false);
      } else {
        ErrorPopup("Đổi số xe thất bại", rs?.message || "");
      }
    } catch (error: any) {
      ErrorPopup("Đổi số xe thất bại", error?.message || "");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button onClick={showModal} className="font-medium w-full">
        Đổi số xe
      </Button>

      <Modal
        title={`Đổi số xe hiện tại: ${bus.busNumber}`}
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={handleUpdateBus}
        okText="Lưu"
        cancelText="Hủy"
        okButtonProps={{ loading }}
        cancelButtonProps={{ disabled: loading }}
      >
        <div className="flex flex-col gap-2">
          <label className="font-medium">Số xe mới</label>
          <Input
            type="number"
            placeholder="Nhập số xe mới"
            value={busNumber}
            onChange={(e) => {
              const value = e.target.value;
              setBusNumber(value === "" ? "" : Number(value));
            }}
            disabled={loading}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ButtonRenameBus;
